<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3" ref="searchDiv">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索商戶賬號" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					
					
					
					
					
					
					
				
					
					
					<el-row  :gutter="20" >
						<el-col :span="6" :xs="12">
							<el-tag >總費用：HK${{total_list.total}}</el-tag>
						</el-col>
						<el-col :span="6"  :xs="12">
							<el-tag type="success" >已支付：HK${{total_list.total_yes}}</el-tag>
						</el-col>
						
						<el-col :span="6" :xs="12" :class="layout.is_phone?'mt-2':''">
							<el-tag type="danger"  >待支付：HK${{total_list.total_no}}</el-tag>
						</el-col>
						<el-col :span="6" :xs="12" :class="layout.is_phone?'mt-2':''">
							<el-tag type="warning">免除：HK${{total_list.total_mian}}</el-tag>
						</el-col>
						
						
						
					</el-row>
					
					
					
					

				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<!-- <el-form-item label="名稱|SKU" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索商品名稱|SKU"></el-input>
						</el-form-item> -->
						
						<!-- <el-form-item label="商戶賬號" class="mb-0">
							<el-input size="small" v-model="from.username" placeholder="搜索商戶賬號"></el-input>
						</el-form-item> -->
						
						
						<el-form-item label="商戶">
							<el-select v-model="from.shop_id" multiple  clearable size="small" filterable placeholder="請選擇" style="width: 85%;">
								<!-- <el-option  label="全部" :value="-1"> -->
								<!-- </el-option> -->
								<el-option v-for="item in shop_list" :key="item.id" :label="item.name+'（'+item.username+')'" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item label="狀態" class="mb-0">
							<el-select v-model="from.status" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="待支付" :value="0"></el-option>
								<el-option label="已支付" :value="1"></el-option>
								<el-option label="免除" :value="2"></el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item label="類型" class="mb-0">
							<el-select v-model="from.type" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="入库卸货費用(空运)" :value="1"></el-option>
								<el-option label="入库卸货費用(海运)" :value="2"></el-option>
								<el-option label="产品上架費" :value="3"></el-option>
								<el-option label="订單退货上架" :value="4"></el-option>
								<el-option label="退仓" :value="5"></el-option>
								<el-option label="弃货" :value="6"></el-option>
								<el-option label="订單出库操作費" :value="7"></el-option>
								<el-option label="仓储費" :value="8"></el-option>
								
								
								
							</el-select>
						</el-form-item>
						
						
						<el-form-item label="仓库" prop="go_id">
							<el-select v-model="from.go_id"  size="small" filterable placeholder="請選擇" style="width: 85%;">
								<el-option  label="全部" :value="-1">
								</el-option>
								<el-option v-for="item in go_list" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
					
						
						
					
					


						<el-form-item label="時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							  range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
			
			
			<div class="mb-3">
				
				<!-- <el-button class="mr-2"  @click="openModel(1)" type="primary" size="mini"
				v-auth="'edit'+auth_val">根据商戶设置全部支付</el-button>
				
				<el-button class="mr-2"  @click="openModel(2)" type="warning" size="mini"
				v-auth="'clear'+auth_val">根据商戶设置免除</el-button>
			
				<el-button :class="layout.is_phone?'mt-3':''"  @click="setPay(0,3)" plain  type="primary" v-auth="'edit'+auth_val"  size="mini">选中已支付</el-button>
				<el-button plain @click="setPay(0,4)"   type="warning" v-auth="'clear'+auth_val"  size="mini">选中免除</el-button> -->
				<el-dropdown  placement="bottom-start" @command="selMore">
				  <el-button type="primary" size="mini">
				    批量操作<i class="el-icon-arrow-down el-icon--right"></i>
				  </el-button>
				  <el-dropdown-menu slot="dropdown">
				    <el-dropdown-item v-auth="'edit'+auth_val" :command="1">根据商家设置支付</el-dropdown-item>
				    <el-dropdown-item v-auth="'clear'+auth_val" :command="2">根据商戶设置免除</el-dropdown-item>
				    <el-dropdown-item v-auth="'edit'+auth_val" :command="3">设置已支付</el-dropdown-item>
				    <el-dropdown-item v-auth="'clear'+auth_val" :command="4">免除</el-dropdown-item>
				  </el-dropdown-menu>
				</el-dropdown>
			
				
				
			</div>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			
			
			
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange"  @expand-change="checkLog" :max-height="tableHeight">
				
				<el-table-column type="selection" width="45" align="center">
				
				</el-table-column>
				<el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column>
				
				
				<!-- <el-table-column align="center" width="60" prop="id" label="ID">
				</el-table-column> -->
				
				
				
				<el-table-column align="center" prop="sp_name" width="150" label="商戶">
					<template slot-scope="v">
						<span>{{v.row.shop_name}}(<span class="text-danger">{{v.row.username}}</span>)</span>
						
					</template>
				</el-table-column>
				
				<el-table-column align="center" width="150" prop="go_type" label="類型">
					<template slot-scope="v">
						<span v-if="v.row.type==1">入库卸货費用(空运)</span>
						<span v-if="v.row.type==2">入库卸货費用(海运)</span>
						<span v-if="v.row.type==3">产品上架費</span>
						<span v-if="v.row.type==4">订單退货上架</span>
						<span v-if="v.row.type==5">退仓</span>
						<span v-if="v.row.type==6">弃货</span>
						<span v-if="v.row.type==7">订單出库操作費</span>
						<span v-if="v.row.type==8">仓储費</span>
					</template>
				</el-table-column>
						
				<el-table-column align="center" width="120" prop="num" label="數量">
					<template slot-scope="v">
						<span  >
							{{v.row.num}}
							<span v-if="v.row.type==1"> KG</span>
							<span v-if="v.row.type==2"> 柜</span>
							<span v-if="v.row.type==6 || v.row.type==8"> 立方</span>
						</span>
						
					</template>
				</el-table-column>
				<el-table-column align="center" prop="money" width="120" label="費用">
					<template slot-scope="v">
						<span style="font-weight: bold;">HK$ {{v.row.money}}</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="go_type" label="狀態">
					<template slot-scope="v">
						<span class="text-success" v-if="v.row.status==1">已支付</span>
						<span style="color: #999;" v-if="v.row.status==0">待支付</span>
						<span class="text-warning" v-if="v.row.status==2">免除</span>
						
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" prop="go_name" width="140" label="仓库"></el-table-column>
				<el-table-column align="center" prop="ins_name" label="操作员"></el-table-column>
				
				<el-table-column width="180" align="center" prop="type_name" label="对应订單/商品">
					<template slot-scope="v">
						<span v-if="v.row.type==8">-</span>
						<span v-else >
							{{v.row.type_name}}
							<!-- <span v-if="v.row.type==1"> KG</span>
							<span v-if="v.row.type==2"> 柜</span>
							<span v-if="v.row.type==6"> 立方</span> -->
						</span>
						
					</template>
				</el-table-column>
				
				<el-table-column width="180" align="center" prop="create_time" label="時間"></el-table-column>
				<el-table-column width="120" align="center" prop="ad_name" label="管理员"></el-table-column>
				<el-table-column width="180" align="center" prop="status_time" label="操作時間"></el-table-column>
			
				
			
				
				
				
				
			<!-- 	
				<el-table-column align="center" width="150"  prop="status"  label="類型">
					<template slot-scope="v">
						<el-tag size="mini" v-if="v.row.type==1">系统通知</el-tag>
						<el-tag size="mini" v-if="v.row.type==2" type="success">後台公告</el-tag>
					</template>
				</el-table-column> -->
				
		
				
				
		
				
				
	
				
		
				
		
				
	
			
				
				
	
				
		
				
				
				
				
				<!-- <el-table-column align="center" prop="create_time" width="200" label="發送時間">
					
				</el-table-column>
				 -->
				
				<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="150" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							
							
							
							<el-button v-if="scope.row.status ==0" v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="setPay(scope.row.id,1)">已支付</el-button>
							
							<el-button v-if="scope.row.status ==0" v-auth="'clear'+auth_val" size="mini" plain type="warning" @click="setPay(scope.row.id,2)">免除</el-button>
							
							

						</el-button-group>
					</template>
				</el-table-column>
				
			
				
				

				
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog :close-on-click-modal="false"  :title="form.type==1?'设置商戶費用已支付':'免除商戶費用'" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
				
				
				<el-form-item label="商戶" prop="shop_id">
					<el-select v-model="form.shop_id"  size="small" filterable placeholder="請選擇" style="width: 85%;">
						
						<el-option v-for="item in shop_list" :key="item.id" :label="item.name+'（'+item.username+')'" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
			
			
				
				<el-form-item label="提示">
					<span class="text-danger" v-if="form.type==1">将选中商戶未支付費用全部设置为已支付</span>
					<span class="text-danger" v-if="form.type==2">将选中商戶未支付費用全部免除,請確定後操作！</span>
				</el-form-item>
			
				
				
				
	
				
			
			
			
				
		
				
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" :loading="layout.loading" :disabled="layout.loading" @click="submit">確 定</el-button>
			</div>
		</el-dialog>
		


		
		
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				rules: {
					shop_id: [{
							required: true,
							message: "請選擇商戶",
							trigger: 'blur',
						},
					],
					
					
					
				},
				lookModel:false,
				lookData:{
					title:'',
					content:'',
					time:''
				},
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					status:-1,
					shop_id:'',
					type:-1,
					go_id:-1,
					time: [],
				},
				model_title: 'Money',
				auth_val: 'Money',
				preUrl: "data/moneyList", //列表地址
				addUrl: "data/addMoney", //添加/修改地址
				delAllUrl: "data/delMoneyAll", //批量删除地址
				delUrl: "data/delMoney", //删除單条地址
				editStatusUrl: "data/editStatusMoney", //修改狀態地址
				tableData: [],
				form: {
					id: 0,
					shop_id:'',
					type:"",
					
				},
				morebtn:'',
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],
				slist:[],
				shop_list:[],
				go_list:[],
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			this.commonList('moneyList');
		},
		methods: {
			selMore(command){
				if(command==1 || command ==2){
					this.openModel(command)
				}else{
					this.setPay(0,command)
					
				}
				
			},
			checkNotice(e){
				e.is_read = 1
				
				this.layout.showNoticeModel(e)
				
				
				
			},
			
			checkLog(row,expandedRows){
				if(row.is_check_msg==0){
					this.checkLogApi(row)
					
				}
			},
			
			setPay(id,type){
				let tis = '是否確定此条費用已收款？'
				if(type==2){
					tis = '是否免除此条費用？'
				}
				if(type==3){
					tis = '是否確定當前选中費用已收款？'
				}
				if(type==4){
					tis = '是否免除當前选中費用？'
				}
				let newids = []
				if(type==1 || type==2){
					
					newids.push(id)
				}else{
					if(this.ids.length==0){
						this.$message({
							message: '請先選擇要操作的數据',
							type: 'error'
						});
						return false
					}
					
					newids = this.ids
				}
				
				this.$confirm(tis, '提示', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.layout.loading = true;
					this.axios.post(this.changeStatusUrl(), {
						ids: newids,
						type: type
					}, {
						token: true,
						loading: true
					}).then(res => {
			
						this.multipleSelection = []
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.getList()
			
						this.layout.loading = false;
					}).catch(err => {
						this.layout.loading = false;
					})
				})
				
			},
			
			checkLogApi(row){
					this.axios.post('/admin/user/checkProductNumLog',
						{id:row.id}
					, {
						token: true,
					}).then(res => {
						let all = res.data
						if(all.code==1){
							row.is_check_msg = 1
							console.log(all.data)
							row.log = all.data.list.list
						}	
					}).catch(err => {
						// 失敗
						
					})
				
			},
			
			
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					
					let list = all.data.list
					this.shop_list = list.shop_list
					this.go_list = list.go_list
					
			
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			 
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
						
						if(this.form.sendtype==1 && !this.form.shop_id){
							this.$message.error('請選擇店铺');
							return false
						}
						if(this.form.sendtype==2 && !this.form.sid){
							this.$message.error('請選擇店長');
							return false
						}
					
					
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				// if (!isJPG) {
				//   this.$message.error('上傳头像图片只能是 JPG 格式!');
				// }
				// if (!isLt2M) {
				//   this.$message.error('上傳头像图片大小不能超過 2MB!');
				// }
				return isJPG && isLt2M;
			  },
			

			// 打开模态框
			openModel(type) {
				// 修改
				this.form = {
					id:  0,
					shop_id: '',
					type:type
				}
				this.editIndex = -1
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					status:-1,
					shop_id:'',
					type:-1,
					go_id:-1,
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
